export class SendMessageModel {
    public messageSchemaCode: string;
    public message: string;
    public sender: string;
    public receiver: string;
}